import { Button, Text } from '@epam/promo';
import { FlexRow } from '@epam/uui-components';
import { LoginContainer } from 'components/layouts/LoginContainer';
import { redirectToAuth } from 'api/auth.service';
import { useUserStore } from 'store/user.store';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import LoginBotIcon from '../../assets/images/login-bot.png';
import css from './LoginPage.module.scss';

export const LoginPage = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const user = useUserStore((state) => state.user);

  const handleRedirect = () => {
    setLoading(true);
    redirectToAuth();

    setTimeout(() => {
      setLoading(false);
    }, 10000);
  };

  useEffect(() => {
    if (user) {
      navigate('/tasks');
    }
  }, [user, navigate]);

  return (
    <LoginContainer>
      <FlexRow cx={css.loginPage__info}>
        <Text color="gray90" cx={css.loginPage__title} font="sans-semibold">
          HELLO THERE!
        </Text>
        <Text cx={css.loginPage__description} font="sans" fontSize="18">
          Please login
        </Text>
      </FlexRow>
      <img alt="login bot icon" src={LoginBotIcon} />
      <Button
        caption={loading ? 'Checking credentials...' : 'Login'}
        cx={css.loginPage__btn}
        fill="white"
        isDisabled={loading}
        onClick={handleRedirect}
      />
    </LoginContainer>
  );
};
